import MapboxDraw from "@mapbox/mapbox-gl-draw";
import {
  SnapPolygonMode,
  SnapPointMode,
  SnapLineMode,
  SnapModeDrawStyles,
  SnapDirectSelect,
} from "mapbox-gl-draw-snap-mode";

// Draw modes configuration
export const DRAW_MODES = {
  ...MapboxDraw.modes,
  draw_point: SnapPointMode,
  draw_polygon: SnapPolygonMode,
  draw_line_string: SnapLineMode,
  direct_select: SnapDirectSelect,
};

// Draw styles configuration
export const DRAW_STYLES = [
  ...SnapModeDrawStyles,
  {
    id: "gl-draw-polygon-fill",
    type: "fill",
    paint: {
      "fill-color": "#FF0000",
      "fill-opacity": 0.1,
    },
  },
  {
    id: "gl-draw-polygon-stroke",
    type: "line",
    paint: {
      "line-color": "#FF0000",
      "line-width": 2,
    },
  },
];

// Snap options configuration - optimized for touch
export const SNAP_OPTIONS = {
  snapPx: 30, 
  snapToMidPoints: true,
  snapVertexPriorityDistance: 0.001,
  snapToSegments: false,
  snapToVertices: true,
  snapDistance: 15, 
};

// Draw controls configuration
export const DRAW_CONTROLS = {
  point: true,
  line_string: true,
  polygon: true,
};

// Custom marker configuration
export const MARKER_CONFIG = {
  imagePath: "/red_star.png",
  width: "32px", 
  height: "32px", 
};

// Touch-specific configuration
export const TOUCH_CONFIG = {
  enabled: true,
  tolerance: 15, // Pixel tolerance for touch events
  longPressDelay: 500, // ms
  doubleTapDelay: 300, // ms
};